// src/pages/HomePage.jsx
import React from 'react';
import logo from '../../assets/images/Logo_Negro_Verde_2.png';
import style from './styles/Header.module.css';

const Header = () => {
  return (
    <div className={style.mainContainerHeader}>
      <header className={style.header}>
        <img src={logo} className={style.logoHeader} />
      </header>
    </div>
  );
};

export default Header;
